{
  "nm": "Main Scene",
  "ddd": 0,
  "h": 300,
  "w": 300,
  "meta": { "g": "@lottiefiles/creator 1.86.0" },
  "layers": [
    {
      "ty": 3,
      "nm": "Group Layer 1",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [191.62, 81] },
        "s": { "a": 0, "k": [42.857143, 42.857143] },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [300, 300] },
        "r": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "ind": 1
    },
    {
      "ty": 4,
      "nm": "Shape Layer 5",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [114.344002, 57.251999] },
        "s": { "a": 0, "k": [100, 100] },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [160.661207, 107.754323] },
        "r": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "nm": "Group 11",
          "it": [
            {
              "ty": "gr",
              "bm": 0,
              "hd": false,
              "nm": "Group 9",
              "it": [
                {
                  "ty": "sh",
                  "bm": 0,
                  "hd": false,
                  "nm": "Path 30",
                  "d": 1,
                  "ks": {
                    "a": 1,
                    "k": [
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.66, 87.9443],
                              [196.933, 76.0448],
                              [228.211433, 57.032891],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.66, 87.9443]
                            ]
                          }
                        ],
                        "t": 0
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-9.114192, 1.969614],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [9.114192, -1.969614],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.66, 87.9443],
                              [199.717149, 97.681142],
                              [228.211433, 87.9443],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.66, 87.9443]
                            ]
                          }
                        ],
                        "t": 10
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-8.971267, 1.870604],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [8.971267, -1.870604],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.66, 87.9443],
                              [200.069501, 97.924593],
                              [228.688, 86.763327],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.66, 87.9443]
                            ]
                          }
                        ],
                        "t": 20
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-8.92503, 1.284016],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [8.92503, -1.284016],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.66, 87.9443],
                              [199.672147, 97.522926],
                              [228.688, 86.763327],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.66, 87.9443]
                            ]
                          }
                        ],
                        "t": 30
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-9.035089, 0.049191],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [9.03509, -0.049191],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.66, 87.9443],
                              [195.759338, 83.561763],
                              [228.727, 86.763327],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.66, 87.9443]
                            ]
                          }
                        ],
                        "t": 40
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-9.035089, 0.049191],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [9.03509, -0.049191],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [195.759338, 83.561763],
                              [228.688, 86.763327],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 50
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-8.509719, 1.188692],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [8.509719, -1.188692],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [195.664968, 75.380705],
                              [228.305803, 78.0314],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 60
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-10.020005, 17.499657],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [10.020005, -17.499657],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [195.759338, 83.561763],
                              [228.280663, 65.987516],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 70
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-13.750305, 25.651364],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [13.750305, -25.651364],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [195.759338, 83.561763],
                              [228.280663, 56.226448],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 80
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-11.117096, 13.039305],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [11.117096, -13.039305],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [203.452065, 64.2523],
                              [228.211433, 53.467391],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 85
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-9.148105, 2.693922],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [9.148105, -2.693922],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [197.459392, 98.428154],
                              [228.688, 87.656808],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 90
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-8.616731, 0.88058],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [8.616731, -0.880582],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [196.141535, 99.011231],
                              [228.688, 86.763327],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 130
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-8.333275, 1.705543],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [8.333275, -1.705543],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [196.141535, 99.01123],
                              [228.688, 86.763327],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 140
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-7.5025774, 5.983867000000001],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [7.5025774, -5.983867000000001],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [195.32328343303126, 75.12579570996978],
                              [228.688, 74.5194118],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 148
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-7.294903, 7.053448],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [7.294903, -7.053448],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [201.713312, 73.810873],
                              [228.688, 71.458433],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 150
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-17.333227, 15.90442],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [17.333227, -15.90442],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [201.713312, 73.810873],
                              [228.211433, 57.102698],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 160
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-8.610901, 14.004044],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [8.610901, -14.004044],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [207.61863, 70.034269],
                              [228.688, 56.030226],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 165
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-7.071541, 4.489867],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [7.071541, -4.489867],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [204.923796, 95.734232],
                              [228.271106, 89.055556],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 166
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-6.762501, 3.553322],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [6.762502, -3.553323],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [204.998627, 95.771648],
                              [228.727, 86.763327],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 180
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-6.144423, 1.680234],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [6.144423, -1.680234],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [205.14829, 95.846479],
                              [228.688, 86.763327],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 200
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-12.676108, -3.444318],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [12.676108, 3.444318],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [208.341076, 81.491604],
                              [228.688, 86.763327],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 210
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-4.601296, 3.057571],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [4.601296, -3.057571],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [200.661795, 71.841595],
                              [228.305803, 64.482833],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 220.00000000000003
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-1.871758, 12.567436],
                              [-2.05415, -0.627678],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [1.871758, -12.567436],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [204.501436, 76.666599],
                              [228.211433, 63.530934],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 229.99999999999997
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 21.869454],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, -21.869454],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [208.341076, 81.491604],
                              [228.211433, 58.207141],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 240
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-2.392664, 10.934728],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [2.392664, -10.934726],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [208.647233, 68.257974],
                              [228.211434, 52.568473],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 245.00000000000003
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-4.785328, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [4.785328, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [206.270757, 94.795296],
                              [228.688, 86.503945],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 246
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-4.752015, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [4.752014, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [206.891028, 89.628481],
                              [228.688, 86.763327],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 260
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-4.718701, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [4.718701, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [207.511298, 84.461665],
                              [228.727, 86.763327],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 270
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-4.718701, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [4.718701, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [207.511298, 84.461665],
                              [228.727, 86.763327],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 280
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-8.507694, -4.708898],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [8.507694, 4.708898],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [204.172662, 78.902933],
                              [228.688, 86.763327],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 290
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-10.8514065, 8.2493445],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [10.8514065, -8.2493445],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [182.7595433413762, 82.33103877457724],
                              [199.23456346374627, 73.97539840936554],
                              [228.4843315, 75.1459655],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 295
                      },
                      {
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-13.195119, 21.207587],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [13.195119, -21.207587],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [200.338761, 84.153604],
                              [228.280663, 63.528604],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 300
                      }
                    ]
                  }
                },
                {
                  "ty": "fl",
                  "bm": 0,
                  "hd": false,
                  "nm": "Fill",
                  "c": { "a": 0, "k": [0.9412, 0.9412, 0.9412] },
                  "r": 2,
                  "o": { "a": 0, "k": 100 }
                },
                {
                  "ty": "tr",
                  "a": { "a": 0, "k": [200.174004, 45.556244] },
                  "s": { "a": 0, "k": [100, 100] },
                  "sk": { "a": 0, "k": 0 },
                  "p": { "a": 0, "k": [200.175006, 45.75894] },
                  "r": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 },
                  "o": { "a": 0, "k": 100 }
                }
              ]
            },
            {
              "ty": "gr",
              "bm": 0,
              "hd": false,
              "nm": "Group 10",
              "it": [
                {
                  "ty": "sh",
                  "bm": 0,
                  "hd": false,
                  "nm": "Path 31",
                  "d": 1,
                  "ks": {
                    "a": 1,
                    "k": [
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [19.090836, -6.249354],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-20.702515, -5.830291],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.3162, 101.221],
                              [25.4062, 112.901],
                              [-0.009487, 128.003433],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [150.592855, 96.8702],
                              [71.499641, 96.8702],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 0
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [19.520628, -4.78026],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.326866, -4.114698],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.3162, 101.221],
                              [25.4062, 112.901],
                              [0.070328, 106.28584],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [150.592855, 96.8702],
                              [70.999811, 96.8702],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 10
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [19.95042, -3.311167],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.3162, 101.221],
                              [25.4062, 112.901],
                              [0.070328, 112.901],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [150.592855, 96.8702],
                              [70.999811, 96.8702],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 20
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.3162, 101.221],
                              [24.210735, 102.744033],
                              [0.070328, 102.744033],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [141.622497, 90.987033],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 40
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [4.769693, -6.208641],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-7.289797, 3.284145],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.305711, 108.318981],
                              [23.608475, 109.586969],
                              [0.070328, 102.744033],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 50
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [9.478096, -12.717008],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-10.641308, -6.039975],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.305711, 112.3667],
                              [11.676253, 117.805489],
                              [0.070328, 102.744033],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 60
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [9.936935, -17.781818],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-11.881778, -4.276412],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.305711, 107.309238],
                              [15.79562, 119.41009],
                              [0.070328, 122.623433],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 70
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [9.869793, -5.920348],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-14.267684, 0.781051],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.305711, 102.251775],
                              [22.675808, 116.138013],
                              [0.070328, 128.003433],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 80
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [9.869793, -5.920348],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-14.119957, 5.613758],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.305711, 102.251775],
                              [22.675808, 116.138013],
                              [0.070328, 115.258806],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 100
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [9.869794, -5.920348],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-14.119957, 5.613758],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.305711, 102.251775],
                              [22.760022, 112.887623],
                              [0.070328, 107.865533],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 110.00000000000001
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [9.869793, -5.920348],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-14.119957, 5.613758],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.305711, 102.251775],
                              [22.844237, 109.637233],
                              [0.070328, 107.865533],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 120
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.031508, 1.432323],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-10.067914, 1.14353],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.305711, 106.722003],
                              [21.973057, 106.722003],
                              [0.070328, 107.865533],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 130
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [11.762661, -16.705092],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-18.138617, -4.475757],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.305711, 111.192231],
                              [9.232286, 120.280626],
                              [0.070328, 107.865533],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [140.659812, 90.987033],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 140
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [11.762661, -16.705092],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-6.015872, -3.326698],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.386528, 105.001568],
                              [21.966607, 119.449125],
                              [0.070328, 128.003433],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 150
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [11.762661, -16.705092],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-6.015872, -3.326698],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.386528, 105.001568],
                              [21.966607, 119.449125],
                              [0.070328, 116.138013],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 160
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [11.762661, -16.705092],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [15.323507, -0.31535],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-6.015872, -3.326698],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.386528, 105.001568],
                              [21.966607, 115.381729],
                              [0.070328, 112.001773],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 170
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [11.762661, -16.705092],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-6.015872, -3.326698],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.386528, 105.001568],
                              [21.966607, 111.314333],
                              [0.070328, 107.865533],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 180
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [18.181996, -3.128698],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-6.71321, -1.942106],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.305711, 107.865533],
                              [26.047907, 107.865533],
                              [0.070328, 107.865533],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 190
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [14.601685, -18.028851],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-4.728873, -3.548622],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.305711, 112.434913],
                              [6.669004, 120.280626],
                              [0.070328, 107.865533],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [141.660015, 91.275826],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 200
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [12.630557, -16.206076],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-4.728873, -3.548622],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.386528, 104.342874],
                              [18.541578, 118.742351],
                              [0.070328, 122.623433],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 210
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [12.630557, -16.206076],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-4.728873, -3.548622],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.386528, 104.342874],
                              [23.281313, 119.991833],
                              [0.070328, 128.003433],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 220.00000000000003
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [12.630557, -16.206076],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-4.728873, -3.548622],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.386528, 104.342874],
                              [23.281313, 119.991833],
                              [0.070328, 128.003433],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 229.99999999999997
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [12.630557, -16.206076],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-4.728873, -3.548622],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.386528, 104.342874],
                              [23.281313, 119.991833],
                              [0.070328, 111.314333],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 240
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [12.630557, -16.206076],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-4.728873, -3.548622],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.386528, 104.342874],
                              [23.281313, 119.991833],
                              [0.070328, 107.865533],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 250
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [12.630557, -16.206076],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-4.728873, -3.548622],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.386528, 104.342874],
                              [23.15625, 109.637233],
                              [0.070328, 107.865533],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 260
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [12.630557, -16.206076],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-4.728873, -3.548622],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.386528, 104.342874],
                              [23.15625, 109.637233],
                              [0.070328, 107.865533],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 270
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [12.630557, -16.206076],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-4.728873, -3.548622],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.386528, 104.342874],
                              [23.15625, 109.637233],
                              [0.070328, 107.865533],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 280
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0.802171, -8.721565],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-18.718848, -1.346894],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.305711, 105.620689],
                              [29.354941, 129.682826],
                              [0.070328, 107.865533],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 290
                      },
                      {
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0.000506, -4.9168],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-6.180296, 1.7717],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.3162, 107.865533],
                              [42.283633, 126.587801],
                              [0.070328, 128.003433],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [75.301321, 100.267585],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 300
                      }
                    ]
                  }
                },
                {
                  "ty": "fl",
                  "bm": 0,
                  "hd": false,
                  "nm": "Fill",
                  "c": { "a": 0, "k": [0.9412, 0.9412, 0.9412] },
                  "r": 2,
                  "o": { "a": 0, "k": 100 }
                },
                {
                  "ty": "tr",
                  "a": { "a": 0, "k": [75.626503, 57.251999] },
                  "s": { "a": 0, "k": [100, 100] },
                  "sk": { "a": 0, "k": 0 },
                  "p": { "a": 0, "k": [75.81697, 57.251999] },
                  "r": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 },
                  "o": { "a": 0, "k": 100 }
                }
              ]
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0] },
              "s": { "a": 0, "k": [100, 100] },
              "sk": { "a": 0, "k": 0 },
              "p": { "a": 0, "k": [0, 0] },
              "r": { "a": 0, "k": 0 },
              "sa": { "a": 0, "k": 0 },
              "o": { "a": 0, "k": 100 }
            }
          ]
        }
      ],
      "ind": 2
    },
    {
      "ty": 4,
      "nm": "Shape Layer 6",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [-2.379581, 1.418099] },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [70, 70],
              "t": 0
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [100, 100],
              "t": 80
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [75, 75],
              "t": 150
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [50, 50],
              "t": 220.00000000000003
            },
            { "s": [70, 70], "t": 300 }
          ]
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [26.514628, 161.999141],
              "t": 0
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [25.371695, 176.724061],
              "t": 20,
              "ti": [-9.40096, 0],
              "to": [4.051193, 5.665866]
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [42.245659, 183.131945],
              "t": 40,
              "ti": [0, 0],
              "to": [9.40096, 0]
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [78.129078, 183.761569],
              "t": 60,
              "ti": [0, 0],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [100.292075, 182.159686],
              "t": 80
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [125.507503, 179.34852],
              "t": 100
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [150.185173, 175.336236],
              "t": 120
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [194.077866, 164.884],
              "t": 140,
              "ti": [-7.883025, 2.38324],
              "to": [23.636028, -6.696923]
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [263.202197, 142.460346],
              "t": 150,
              "ti": [0.455857, 5.51645],
              "to": [7.883025, -2.38324]
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [276.733682, 128.166446],
              "t": 160,
              "ti": [0, 0],
              "to": [-0.455857, -5.51645]
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [263.004171, 117.774761],
              "t": 180,
              "ti": [11.792437, -0.302814],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [238.424233, 116.106676],
              "t": 200,
              "ti": [0, 0],
              "to": [-11.792436, 0.302813]
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [205.780413, 117.774761],
              "t": 220.00000000000003
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [180.538913, 121.190846],
              "t": 240,
              "ti": [0, 0],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [145.27828, 128.166446],
              "t": 260,
              "ti": [11.837168, -2.188069],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [115.95502, 134.136446],
              "t": 280,
              "ti": [11.937822, -8.507923],
              "to": [-11.837168, 2.188069]
            },
            { "s": [26.514628, 161.999141], "t": 300 }
          ]
        },
        "r": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "shapes": [
        {
          "ty": "el",
          "bm": 0,
          "hd": false,
          "nm": "Ellipse 1",
          "d": 1,
          "p": { "a": 0, "k": [0, 0] },
          "s": { "a": 0, "k": [55, 55] }
        },
        {
          "ty": "st",
          "bm": 0,
          "hd": false,
          "nm": "Stroke",
          "lc": 1,
          "lj": 1,
          "ml": 4,
          "o": { "a": 0, "k": 100 },
          "w": { "a": 0, "k": 5 },
          "d": [{ "nm": "offset", "n": "o", "v": { "a": 0, "k": 0 } }],
          "c": { "a": 0, "k": [0.9412, 0.9412, 0.9412] }
        },
        {
          "ty": "fl",
          "bm": 0,
          "hd": false,
          "nm": "Fill",
          "c": { "a": 0, "k": [0.1804, 0.1882, 0.2118] },
          "r": 2,
          "o": { "a": 0, "k": 100 }
        }
      ],
      "ind": 3
    },
    {
      "ty": 4,
      "nm": "Shape Layer 7",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [0, 0] },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [50, 50],
              "t": 0
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [70, 70],
              "t": 80
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [100, 100],
              "t": 150
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [75, 75],
              "t": 220.00000000000003
            },
            { "s": [50, 50], "t": 300 }
          ]
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [180.538913, 121.190846],
              "t": 0
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [157.464487, 128.455241],
              "t": 20,
              "ti": [11.837168, -2.188069],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [115.95502, 134.136446],
              "t": 40,
              "ti": [13.303734, -1.203314],
              "to": [-11.837168, 2.188069]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [64.825344, 143.66366],
              "t": 60,
              "ti": [5.212522, -3.625478],
              "to": [-13.303734, 1.203314]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [27.067209, 161.999141],
              "t": 80,
              "ti": [-5.746212, -4.890248],
              "to": [-5.212522, 3.625478]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [21.607135, 175.419953],
              "t": 100,
              "ti": [-15.375775, -1.229676],
              "to": [5.746212, 4.890248]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [42.245659, 183.131945],
              "t": 120,
              "ti": [0, 0],
              "to": [15.375775, 1.229677]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [78.129078, 183.761569],
              "t": 140,
              "ti": [0, 0],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [99.827552, 182.233981],
              "t": 150
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [126.820634, 179.072848],
              "t": 160
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [150.185173, 175.336236],
              "t": 180
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [194.077866, 164.884],
              "t": 200,
              "ti": [-11.972887, 10.49305],
              "to": [23.636028, -6.696923]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [268.081569, 138.298396],
              "t": 220.00000000000003,
              "ti": [-1.748648, 3.538238],
              "to": [2.573348, -1.537889]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [276.733682, 128.166446],
              "t": 240,
              "ti": [13.638631, 3.416085],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [263.004171, 117.774761],
              "t": 260,
              "ti": [11.792437, -0.302814],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [238.424233, 116.106676],
              "t": 280,
              "ti": [0, 0],
              "to": [-11.792436, 0.302813]
            },
            { "s": [180.538913, 121.190846], "t": 300 }
          ]
        },
        "r": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "shapes": [
        {
          "ty": "el",
          "bm": 0,
          "hd": false,
          "nm": "Ellipse 2",
          "d": 1,
          "p": { "a": 0, "k": [0, 0] },
          "s": { "a": 0, "k": [55, 55] }
        },
        {
          "ty": "st",
          "bm": 0,
          "hd": false,
          "nm": "Stroke",
          "lc": 1,
          "lj": 1,
          "ml": 4,
          "o": { "a": 0, "k": 100 },
          "w": { "a": 0, "k": 5 },
          "d": [{ "nm": "offset", "n": "o", "v": { "a": 0, "k": 0 } }],
          "c": { "a": 0, "k": [0.9412, 0.9412, 0.9412] }
        },
        {
          "ty": "fl",
          "bm": 0,
          "hd": false,
          "nm": "Fill",
          "c": { "a": 0, "k": [0.1804, 0.1882, 0.2118] },
          "r": 2,
          "o": { "a": 0, "k": 100 }
        }
      ],
      "ind": 4
    },
    {
      "ty": 4,
      "nm": "Shape Layer 8",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [2.357611, 1.612885] },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [75, 75],
              "t": 0
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [50, 50],
              "t": 80
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [70, 70],
              "t": 150
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [100, 100],
              "t": 220.00000000000003
            },
            { "s": [75, 75], "t": 300 }
          ]
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [279.097823, 135.001313],
              "t": 0
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [281.92891, 122.638903],
              "t": 10,
              "ti": [4.372994, 1.095309],
              "to": [-0.428169, -1.621483]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [275.006207, 116.395471],
              "t": 20,
              "ti": [11.792437, -0.302814],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [238.424233, 116.106676],
              "t": 40,
              "ti": [0, 0],
              "to": [-11.792436, 0.302813]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [205.965586, 117.774761],
              "t": 60,
              "ti": [0, 0],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [180.538913, 121.190846],
              "t": 80,
              "ti": [0, 0],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [145.27828, 128.166446],
              "t": 100,
              "ti": [11.837168, -2.188069],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [115.95502, 134.136446],
              "t": 120,
              "ti": [11.81006, -4.16195],
              "to": [-11.837168, 2.188069]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [66.319018, 142.460346],
              "t": 140,
              "ti": [5.212522, -3.625478],
              "to": [-11.81006, 4.16195]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [27.067209, 160.646772],
              "t": 150,
              "ti": [-5.746212, -4.890248],
              "to": [-5.212522, 3.625478]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [20.428567, 179.072848],
              "t": 160,
              "ti": [-8.150653, 0],
              "to": [5.746212, 4.890248]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [42.245659, 183.131945],
              "t": 180,
              "ti": [0, 0],
              "to": [8.150653, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [78.129078, 183.761569],
              "t": 200,
              "ti": [0, 0],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [98.810855, 182.233981],
              "t": 220.00000000000003
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [128.381632, 179.25954],
              "t": 240
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [150.185173, 175.336236],
              "t": 260
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [194.077866, 164.884],
              "t": 280,
              "ti": [-11.568804, 13.078819],
              "to": [23.636028, -6.696923]
            },
            { "s": [279.097823, 135.771223], "t": 300 }
          ]
        },
        "r": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "shapes": [
        {
          "ty": "el",
          "bm": 0,
          "hd": false,
          "nm": "Ellipse 3",
          "d": 1,
          "p": { "a": 0, "k": [0, 0] },
          "s": { "a": 0, "k": [55, 55] }
        },
        {
          "ty": "st",
          "bm": 0,
          "hd": false,
          "nm": "Stroke",
          "lc": 1,
          "lj": 1,
          "ml": 4,
          "o": { "a": 0, "k": 100 },
          "w": { "a": 0, "k": 5 },
          "d": [{ "nm": "offset", "n": "o", "v": { "a": 0, "k": 0 } }],
          "c": { "a": 0, "k": [0.9412, 0.9412, 0.9412] }
        },
        {
          "ty": "fl",
          "bm": 0,
          "hd": false,
          "nm": "Fill",
          "c": { "a": 0, "k": [0.1804, 0.1882, 0.2118] },
          "r": 2,
          "o": { "a": 0, "k": 100 }
        }
      ],
      "ind": 5
    },
    {
      "ty": 4,
      "nm": "Shape Layer 9",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [0, 0] },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [100, 100],
              "t": 0
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [74.6314, 74.6314],
              "t": 80
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [50, 50],
              "t": 150
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [70, 70],
              "t": 220.00000000000003
            },
            { "s": [100, 100], "t": 300 }
          ]
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [126.310855, 179.864195],
              "t": 0
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [162.37138, 175.625031],
              "t": 20
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [194.077866, 164.884],
              "t": 40,
              "ti": [-6.767305, 2.646525],
              "to": [23.636028, -6.696923]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [248.861955, 149.337663],
              "t": 60,
              "ti": [-7.38812, 14.2939],
              "to": [14.142216, -6.877317]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [276.733682, 128.166446],
              "t": 80,
              "ti": [13.638631, 3.416085],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [263.004171, 117.774761],
              "t": 100,
              "ti": [11.792437, -0.302814],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [238.424233, 116.106676],
              "t": 120,
              "ti": [0, 0],
              "to": [-11.792436, 0.302813]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [205.965586, 117.774761],
              "t": 140,
              "ti": [0, 0],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [180.538913, 121.190846],
              "t": 150,
              "ti": [0, 0],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [145.27828, 128.166446],
              "t": 160,
              "ti": [11.837168, -2.188069],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [115.054804, 134.136446],
              "t": 180,
              "ti": [11.81006, -4.16195],
              "to": [-11.837168, 2.188069]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [66.319018, 142.460346],
              "t": 200,
              "ti": [5.212522, -3.625478],
              "to": [-11.81006, 4.16195]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [27.067209, 158.923396],
              "t": 220.00000000000003,
              "ti": [-5.746212, -4.890248],
              "to": [-5.212522, 3.625478]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [25.004709, 179.25954],
              "t": 240,
              "ti": [-8.003723, 0],
              "to": [5.746212, 4.890248]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [42.245659, 183.131945],
              "t": 260,
              "ti": [0, 0],
              "to": [8.003723, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [78.129078, 183.761569],
              "t": 280,
              "ti": [0, 0],
              "to": [0, 0]
            },
            { "s": [126.152713, 179.882138], "t": 300 }
          ]
        },
        "r": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "shapes": [
        {
          "ty": "el",
          "bm": 0,
          "hd": false,
          "nm": "Ellipse 4",
          "d": 1,
          "p": { "a": 0, "k": [0, 0] },
          "s": { "a": 0, "k": [55, 55] }
        },
        {
          "ty": "st",
          "bm": 0,
          "hd": false,
          "nm": "Stroke",
          "lc": 1,
          "lj": 1,
          "ml": 4,
          "o": { "a": 0, "k": 100 },
          "w": { "a": 0, "k": 5 },
          "d": [{ "nm": "offset", "n": "o", "v": { "a": 0, "k": 0 } }],
          "c": { "a": 0, "k": [0.9412, 0.9412, 0.9412] }
        },
        {
          "ty": "fl",
          "bm": 0,
          "hd": false,
          "nm": "Fill",
          "c": { "a": 0, "k": [0.1804, 0.1882, 0.2118] },
          "r": 2,
          "o": { "a": 0, "k": 100 }
        }
      ],
      "ind": 6
    },
    {
      "ty": 4,
      "nm": "Shape Layer 10",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [138.50655, 37.497608] },
        "s": { "a": 0, "k": [99, 99] },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [159.67002, 150.187899] },
        "r": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "nm": "Group 18",
          "it": [
            {
              "ty": "gr",
              "bm": 0,
              "hd": false,
              "nm": "Group 12",
              "it": [
                {
                  "ty": "sh",
                  "bm": 0,
                  "hd": false,
                  "nm": "Path 32",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "c": true,
                      "i": [
                        [0, 0],
                        [0, 0],
                        [-13.555, 7.0996],
                        [0, 0],
                        [25.523, -6.5664]
                      ],
                      "o": [
                        [0, 0],
                        [23.621, -6.5084],
                        [0, 0],
                        [-11.194, 6.1314],
                        [0, 0]
                      ],
                      "v": [
                        [199.410388, 44.192014],
                        [199.410387, 53.556478],
                        [257.015, 32.62],
                        [257.015, 24.5069],
                        [199.410388, 44.192014]
                      ]
                    }
                  }
                },
                {
                  "ty": "fl",
                  "bm": 0,
                  "hd": false,
                  "nm": "Fill",
                  "c": { "a": 0, "k": [0.1804, 0.1882, 0.2118] },
                  "r": 2,
                  "o": { "a": 0, "k": 100 }
                },
                {
                  "ty": "tr",
                  "a": { "a": 0, "k": [228.566505, 38.9963] },
                  "s": { "a": 0, "k": [100, 100] },
                  "sk": { "a": 0, "k": 0 },
                  "p": { "a": 0, "k": [226.579456, 39.138976] },
                  "r": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 },
                  "o": { "a": 0, "k": 100 }
                }
              ]
            },
            {
              "ty": "gr",
              "bm": 0,
              "hd": false,
              "nm": "Group 13",
              "it": [
                {
                  "ty": "sh",
                  "bm": 0,
                  "hd": false,
                  "nm": "Path 33",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "c": true,
                      "i": [
                        [0, 0],
                        [18.044, -3.1816],
                        [5.276, -0.8273],
                        [0, 0],
                        [-2.744, 0.4838],
                        [-17.079, 4.706],
                        [0, 0]
                      ],
                      "o": [
                        [-15.38, 3.7661],
                        [-5.437, 0.9587],
                        [0, 0],
                        [2.71, -0.4439],
                        [20.3, -3.5794],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [191.972603, 45.925037],
                        [142.438, 56.5131],
                        [125.941331, 59.1923],
                        [134.932314, 67.4768],
                        [143.622, 66.0854],
                        [200.118, 53.4857],
                        [191.972603, 45.925037]
                      ]
                    }
                  }
                },
                {
                  "ty": "fl",
                  "bm": 0,
                  "hd": false,
                  "nm": "Fill",
                  "c": { "a": 0, "k": [0.1804, 0.1882, 0.2118] },
                  "r": 2,
                  "o": { "a": 0, "k": 100 }
                },
                {
                  "ty": "tr",
                  "a": { "a": 0, "k": [163.238499, 56.723999] },
                  "s": { "a": 0, "k": [100, 100] },
                  "sk": { "a": 0, "k": 0 },
                  "p": { "a": 0, "k": [160.543837, 56.937453] },
                  "r": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 },
                  "o": { "a": 0, "k": 100 }
                }
              ]
            },
            {
              "ty": "gr",
              "bm": 0,
              "hd": false,
              "nm": "Group 14",
              "it": [
                {
                  "ty": "sh",
                  "bm": 0,
                  "hd": false,
                  "nm": "Path 34",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "c": true,
                      "i": [
                        [0, 0],
                        [0.4362, 0.0656],
                        [0, 0],
                        [-0.4516, -0.0616],
                        [-22.7696, 1.6372],
                        [0, 0],
                        [12.4337, 1.6393]
                      ],
                      "o": [
                        [-0.4565, -0.0601],
                        [0, 0],
                        [0.4411, 0.0651],
                        [14.3114, 1.9514],
                        [0, 0],
                        [-24.2918, 2.2877],
                        [0, 0]
                      ],
                      "v": [
                        [25.3537, 65.8421],
                        [24.0146, 65.6535],
                        [24.0146, 73.1947],
                        [25.3537, 73.3847],
                        [81.92357, 73.769774],
                        [81.924115, 64.712074],
                        [25.3537, 65.8421]
                      ]
                    }
                  }
                },
                {
                  "ty": "fl",
                  "bm": 0,
                  "hd": false,
                  "nm": "Fill",
                  "c": { "a": 0, "k": [0.1804, 0.1882, 0.2118] },
                  "r": 2,
                  "o": { "a": 0, "k": 100 }
                },
                {
                  "ty": "tr",
                  "a": { "a": 0, "k": [53.014601, 69.913307] },
                  "s": { "a": 0, "k": [100, 100] },
                  "sk": { "a": 0, "k": 0 },
                  "p": { "a": 0, "k": [53.014601, 69.913307] },
                  "r": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 },
                  "o": { "a": 0, "k": 100 }
                }
              ]
            },
            {
              "ty": "gr",
              "bm": 0,
              "hd": false,
              "nm": "Group 15",
              "it": [
                {
                  "ty": "sh",
                  "bm": 0,
                  "hd": false,
                  "nm": "Path 35",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "c": true,
                      "i": [
                        [0, 0],
                        [-1.16473, -6.6055],
                        [-14.20996, -2.0968],
                        [0, 0],
                        [0.4988, 2.8291],
                        [-9.4628, 4.5051],
                        [0, 0]
                      ],
                      "o": [
                        [-16.92141, 8.0086],
                        [0.9987, 5.6639],
                        [0, 0],
                        [-7.6424, -1.1493],
                        [-0.5921, -3.3575],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [24.0146, 38.7746],
                        [0.10938, 61.5188],
                        [24.0146, 73.1947],
                        [24.0146, 65.6535],
                        [11.3839, 59.6961],
                        [24.0146, 47.5],
                        [24.0146, 38.7746]
                      ]
                    }
                  }
                },
                {
                  "ty": "sh",
                  "bm": 0,
                  "hd": false,
                  "nm": "Path 36",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "c": true,
                      "i": [
                        [0, 0],
                        [0, 0],
                        [-0.5659, 0.0427],
                        [-18.298, 2.9969],
                        [0, 0],
                        [13.1455, -1.2757],
                        [0.5617, -0.0529]
                      ],
                      "o": [
                        [0, 0],
                        [0.5621, -0.0404],
                        [15.9576, -1.2023],
                        [0, 0],
                        [-15.127, 2.372],
                        [-0.5663, 0.0549],
                        [0, 0]
                      ],
                      "v": [
                        [82.0146, 64.8314],
                        [82.0146, 73.8891],
                        [83.7066, 73.7645],
                        [132.328793, 67.80958],
                        [123.297406, 59.52508],
                        [83.7066, 64.6697],
                        [82.0146, 64.8314]
                      ]
                    }
                  }
                },
                {
                  "ty": "sh",
                  "bm": 0,
                  "hd": false,
                  "nm": "Path 37",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "c": true,
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-2.351, 0.605]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [2.439, -0.5973],
                        [0, 0]
                      ],
                      "v": [
                        [197.474075, 44.454016],
                        [197.453874, 53.749579],
                        [189.328679, 46.257817],
                        [197.474075, 44.454016]
                      ]
                    }
                  }
                },
                {
                  "ty": "sh",
                  "bm": 0,
                  "hd": false,
                  "nm": "Path 38",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "c": true,
                      "i": [
                        [0, 0],
                        [0, 0],
                        [-0.383, 0.2055],
                        [1.006, 5.704],
                        [11.138, 2.23313],
                        [0, 0],
                        [-0.401, -2.2735],
                        [5.917, -3.4054],
                        [0.399, -0.2187]
                      ],
                      "o": [
                        [0, 0],
                        [0.393, -0.2058],
                        [12.808, -6.8813],
                        [-0.871, -4.94111],
                        [0, 0],
                        [5.12, 1.1861],
                        [0.465, 2.6379],
                        [-0.376, 0.2165],
                        [0, 0]
                      ],
                      "v": [
                        [255.09788, 24.5069],
                        [255.09788, 32.62],
                        [256.26088, 32.003],
                        [276.917, 12.7101],
                        [255.09788, 0.391941],
                        [255.09788, 7.963081],
                        [266.677, 14.6809],
                        [256.26088, 23.8541],
                        [255.09788, 24.5069]
                      ]
                    }
                  }
                },
                {
                  "ty": "fl",
                  "bm": 0,
                  "hd": false,
                  "nm": "Fill",
                  "c": { "a": 0, "k": [0.9412, 0.9412, 0.9412] },
                  "r": 2,
                  "o": { "a": 0, "k": 100 }
                },
                {
                  "ty": "tr",
                  "a": { "a": 0, "k": [138.50655, 37.658978] },
                  "s": { "a": 0, "k": [100, 100] },
                  "sk": { "a": 0, "k": 0 },
                  "p": { "a": 0, "k": [138.455813, 37.539652] },
                  "r": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 },
                  "o": { "a": 0, "k": 100 }
                }
              ]
            },
            {
              "ty": "gr",
              "bm": 0,
              "hd": false,
              "nm": "Group 16",
              "it": [
                {
                  "ty": "sh",
                  "bm": 0,
                  "hd": false,
                  "nm": "Path 39",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "c": true,
                      "i": [
                        [0, 0],
                        [0, 0],
                        [-12.842, 1.11743],
                        [0, 0],
                        [18.311, -2.79621]
                      ],
                      "o": [
                        [0, 0],
                        [14.989, -2.2299],
                        [0, 0],
                        [-15.71, 0.960123],
                        [0, 0]
                      ],
                      "v": [
                        [148.722, 5.6229],
                        [158.124, 14.2035],
                        [200.864566, 9.174655],
                        [200.864566, -0.001915],
                        [148.722, 5.6229]
                      ]
                    }
                  }
                },
                {
                  "ty": "fl",
                  "bm": 0,
                  "hd": false,
                  "nm": "Fill",
                  "c": { "a": 0, "k": [0.9412, 0.9412, 0.9412] },
                  "r": 2,
                  "o": { "a": 0, "k": 100 }
                },
                {
                  "ty": "tr",
                  "a": { "a": 0, "k": [174.419998, 7.10175] },
                  "s": { "a": 0, "k": [100, 100] },
                  "sk": { "a": 0, "k": 0 },
                  "p": { "a": 0, "k": [170.97877, 7.37628] },
                  "r": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 },
                  "o": { "a": 0, "k": 100 }
                }
              ]
            },
            {
              "ty": "gr",
              "bm": 0,
              "hd": false,
              "nm": "Group 17",
              "it": [
                {
                  "ty": "sh",
                  "bm": 0,
                  "hd": false,
                  "nm": "Path 40",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "c": true,
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [2.4073, -0.5952]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [-2.4895, 0.586],
                        [0, 0]
                      ],
                      "v": [
                        [83.7066, 28.756],
                        [83.7066, 20.2815],
                        [91.0532, 26.9837],
                        [83.7066, 28.756]
                      ]
                    }
                  }
                },
                {
                  "ty": "fl",
                  "bm": 0,
                  "hd": false,
                  "nm": "Fill",
                  "c": { "a": 0, "k": [0.9412, 0.9412, 0.9412] },
                  "r": 2,
                  "o": { "a": 0, "k": 100 }
                },
                {
                  "ty": "tr",
                  "a": { "a": 0, "k": [87.379898, 24.51875] },
                  "s": { "a": 0, "k": [100, 100] },
                  "sk": { "a": 0, "k": 0 },
                  "p": { "a": 0, "k": [85.524219, 25.923733] },
                  "r": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 },
                  "o": { "a": 0, "k": 100 }
                }
              ]
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0] },
              "s": { "a": 0, "k": [100, 100] },
              "sk": { "a": 0, "k": 0 },
              "p": { "a": 0, "k": [0, 0] },
              "r": { "a": 0, "k": 0 },
              "sa": { "a": 0, "k": 0 },
              "o": { "a": 0, "k": 100 }
            }
          ]
        }
      ],
      "ind": 7
    },
    {
      "ty": 4,
      "nm": "Shape Layer 11",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [249.6505, 217.58] },
        "s": { "a": 0, "k": [100, 100] },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [295.966707, 268.248792] },
        "r": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "shapes": [
        {
          "ty": "sh",
          "bm": 0,
          "hd": false,
          "nm": "Path 41",
          "d": 1,
          "ks": {
            "a": 0,
            "k": {
              "c": true,
              "i": [
                [0, 0],
                [0, 0],
                [0, 0],
                [-20.161596, 0],
                [-7.776269, -7.200461],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [20.161596, 0],
                [8.064364, 7.488094],
                [0, 0],
                [0, 0]
              ],
              "o": [
                [0, 0],
                [0, 0],
                [0, -22.465704],
                [8.928373, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 22.177566],
                [-8.928648, 0],
                [0, 0],
                [0, 0],
                [0, 0]
              ],
              "v": [
                [57.316662, 195.853815],
                [0, 195.853815],
                [0, 36.290625],
                [32.546603, 0],
                [56.164283, 10.080691],
                [171.661433, 115.490426],
                [171.661433, 3.168189],
                [228.69, 3.168189],
                [228.69, 163.019604],
                [196.143535, 199.31],
                [172.23808, 188.653355],
                [57.316662, 83.814078],
                [57.316662, 195.853815]
              ]
            }
          }
        },
        {
          "ty": "fl",
          "bm": 0,
          "hd": false,
          "nm": "Fill",
          "c": { "a": 0, "k": [0.9412, 0.9412, 0.9412] },
          "r": 2,
          "o": { "a": 0, "k": 100 }
        }
      ],
      "ind": 8
    }
  ],
  "v": "5.7.0",
  "fr": 100,
  "op": 300,
  "ip": 0,
  "assets": []
}
